// @flow

import { GET_PROCEDURE } from "../actions"

export default ( state: any = [], action: any ) => {
  switch ( action.type ) {
  case GET_PROCEDURE:
    return action.response
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getProcedure.jsx